export const CustomerOrder = (props) => {
    return (
        <div>
            Order
        </div>
    )
}